__webpack_require__.p = "/quakerankings/";